import React, { useCallback, useEffect, useState } from "react";
import { Button, Checkbox, Form, Select } from "antd";
import { getFormProjectTeam, putProject } from "../../../config";
import { MessageAnt } from "../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../types/messageType";
import { Endpoints } from "../../../config/type_endpoints";
import { replaceIdURL } from "../../../helpers/replaceId";
import { useCheckFormMultiple } from "../../../hooks/useCheckFormMultiple";
import { ContainerModal } from "../../container/ContainerModal";
import { IteamFormModal } from "./IteamFormModal";

const workTeam = {
    responsible: {
        name: "Responsable",
        nameUnit: "responsibleT",
        nameCheck: "responsible",
        field: "responsable",
    },
    art3d: {
        name: "Arte 3D",
        nameUnit: "art3dT",
        nameCheck: "art3d",
        field: "modeling",
    },
    design: {
        name: "Diseño UI/UX",
        nameUnit: "desingT",
        nameCheck: "design",
        field: "design",
    },
    unity: {
        name: "Programación Unity",
        nameUnit: "unityT",
        nameCheck: "unity",
        field: "unity",
    },
    web: {
        name: "Programación Web",
        nameUnit: "webT",
        nameCheck: "web",
        field: "web",
    },
};

const teamsOnResponse = {
    leader: "líder",
    responsible: "responsable",
    web: "web",
    comercial: "comercial",
    unity: "unity",
    art3d: "modeling",
    design: "design"
}


const baseTeams = {
    comercial: [],
    leader: [],
    art3d: [],
    unity: [],
    web: [],
    design: [],
    responsible: [],
};

// className es opcional
const optionsSelect = (data = { value: "", label: "", className: "" }) => data

// propsData viene de ModalServices
export const FormWorkTeam = ({ propsData = { projectDetails: {}, auth: {} }, closeModalAndRefresh, closeModalDetails }) => {

    const [form] = Form.useForm();
    const [teams, setTeams] = useState({});
    const [loading, setLoading] = useState(false);
    const { checkValues, onChangueValue, updateInitValue } = useCheckFormMultiple();


    const updateWorkTeam = useCallback(
        async ({ form, extraData: { idSpace } }) => {
            const url = replaceIdURL(Endpoints.updateProject.team, "spaceId", idSpace);
            const { status } = await putProject(url, form);
            if (status > 0) {
                MessageAnt(MessageType.error, "No se puedo editar equipo");
                return false;
            }
            return true;
        },
        [],
    )

    const finishForm = async (values) => {
        setLoading(true);

        try {
            const newProperties = Object.entries(values).reduce((prev, [field, value]) => {
                const isAdded = checkValues[field] || false;
                const isAdmin = workTeam[field] === undefined;
                prev[field] = isAdded || isAdmin ? value : []
                return prev
            }, {})
            const isUpdate = await updateWorkTeam({ form: { team: newProperties }, extraData: { idSpace: propsData.projectDetails.clickupSpace } })
            if (isUpdate) {
                await closeModalAndRefresh()
                setLoading(false);
                return;
            }
            setLoading(false);
        } finally {
            setLoading(false)
        }
    };

    const getTeamByProject = useCallback(async (team) => {
        console.clear()

        const optionSelectUsers = { ...baseTeams };

        const { status, payload: { payload: areaUsers } } = await getFormProjectTeam();

        if (status === 0) {
            // Mapear usuarios del área a opciones de selección
            Object.entries(optionSelectUsers).forEach(([key, users]) => {
                const nameKey = teamsOnResponse[key];
                const usersArea = areaUsers[nameKey];
                if (nameKey && usersArea) {
                    optionSelectUsers[key] = usersArea.map(user =>
                        optionsSelect({ value: user.id, label: user.name })
                    );
                }
            });

            Object.entries(team).forEach(([key, users]) => {
                const isAllUserOnRequest = users.every(user => optionSelectUsers[key].some(option => option.value === user.userId));
                if (!isAllUserOnRequest) {
                    const findMissingUser = users
                        .filter(user => !optionSelectUsers[key].some(option => option.value === user.userId))
                        .map(user => optionsSelect({ value: user.userId, label: user.name, className: "text-red-500" }));
                    optionSelectUsers[key] = [...optionSelectUsers[key], ...findMissingUser];
                }
            });
        }

        // Mapear usuarios del equipo a opciones de selección
        const dataUser = Object
            .entries(team)
            .reduce((acc, [key, users]) => {
                acc[key] = users.map(user =>
                    optionsSelect({ value: user.userId, label: user.name })
                );
                return acc;
            }, { ...baseTeams });

        // Crear propiedades para el formulario de manera más eficiente
        const formFields = {};
        const propertiesStateSelect = {};

        Object.entries(dataUser).forEach(([key, users]) => {
            const userValues = users.length > 0 ? users.map(user => user.value) : [];
            formFields[key] = userValues;
            if (userValues.length > 0) {
                propertiesStateSelect[key] = userValues;
            }
        });

        return { optionSelectUsers, formFields, propertiesStateSelect };
    }, []);

    const initData = useCallback(async () => {
        const { projectDetails } = propsData;

        const response = await getTeamByProject(projectDetails.team.values);
        const { optionSelectUsers, formFields, propertiesStateSelect } = response;

        form.setFieldsValue(formFields);
        setTeams(optionSelectUsers);
        updateInitValue(propertiesStateSelect);
        // eslint-disable-next-line
    }, [form, getTeamByProject, propsData]);


    useEffect(() => {
        initData();
    }, [initData])


    if (Object.entries(teams).length === 0) return (
        <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
            <ContainerModal
                title={"Editar equipo de trabajo"}
                actionButton={() => {
                    closeModalDetails();
                }}
                className={"w-[500px]"}
            >
                <p>Cargando...</p>
            </ContainerModal>
        </div>
    );

    return (
        <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
            <ContainerModal
                title={"Editar equipo de trabajo"}
                actionButton={() => {
                    closeModalDetails();
                }}
                className={"w-[500px]"}
            >
                <Form form={form} onFinish={finishForm} className="w-full flex flex-col">
                    <IteamFormModal title="Equipo de trabajo">
                        <div className="w-full grid grid-cols-2 gap-2">
                            <div>
                                <p>Líder</p>
                                <Form.Item
                                    name="leader"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Escoge uno por lo menos",
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        placeholder={`Agregar `}
                                        options={teams["leader"]}
                                    />
                                </Form.Item>
                            </div>

                            <div>
                                <p>Comercial</p>
                                <Form.Item
                                    name="comercial"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Escoge uno por lo menos",
                                        },
                                    ]}

                                >
                                    <Select
                                        showSearch
                                        mode="multiple"
                                        placeholder={`Agregar `}
                                        options={teams["comercial"]}
                                    />

                                </Form.Item>
                            </div>
                        </div>
                        <div className="">
                            {Object.entries(workTeam).map(([key, value], index) => (
                                <TeamComponent
                                    key={`${key}-${index}-data-team`}
                                    onChangueValue={(e) => {
                                        onChangueValue(value.nameCheck, e.target.checked);
                                    }}
                                    title={value.name}
                                    value={checkValues[value.nameCheck]}
                                    name={value.nameCheck}
                                    selectData={teams[value.nameCheck]}
                                />
                            ))}
                        </div>
                    </IteamFormModal>
                    <div className="w-full h-[40px] overflow-hidden flex justify-end gap-4">
                        <Button htmlType="button" onClick={closeModalDetails}>
                            Cancelar
                        </Button>
                        <Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
                            Guardar
                        </Button>
                    </div>
                </Form>
            </ContainerModal>
        </div>
    );
};

const TeamComponent = ({ title = "", name = "", value = false, onChangueValue = () => { }, selectData = [] }) => {
    return (
        <div className="min-h-[60px] grid grid-cols-[120px_30px_calc(100%-120px-30px)] items-center">
            <p>{title}</p>
            <Checkbox checked={value} onChange={onChangueValue} />
            <div className="h-full">
                <Form.Item
                    name={name}
                    className={`h-full grid items-center ${!value && "hidden"}`}
                    rules={[
                        {
                            required: value,
                            message: "Escoge uno por lo menos",
                        },
                    ]}
                >
                    <Select
                        options={selectData}
                        showSearch
                        className="text-[12px]"
                        mode="multiple"
                        placeholder={`selecciona uno`}
                    />
                </Form.Item>
            </div>
        </div>
    );
};
